import { render, staticRenderFns } from "./MyFootprint.vue?vue&type=template&id=a735bf76&scoped=true&"
import script from "./MyFootprint.vue?vue&type=script&lang=js&"
export * from "./MyFootprint.vue?vue&type=script&lang=js&"
import style0 from "./MyFootprint.vue?vue&type=style&index=0&lang=less&"
import style1 from "./MyFootprint.vue?vue&type=style&index=1&id=a735bf76&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a735bf76",
  null
  
)

export default component.exports